export var OneAppSpecificCustomTag = /*#__PURE__*/ function(OneAppSpecificCustomTag) {
    OneAppSpecificCustomTag["AppName"] = "videoapp";
    OneAppSpecificCustomTag["Platform"] = "videoplatform";
    OneAppSpecificCustomTag["StreamId"] = "videoguid";
    OneAppSpecificCustomTag["SubType"] = "videosubcat2";
    OneAppSpecificCustomTag["Genre"] = "videosubcat1";
    OneAppSpecificCustomTag["VideoNetwork"] = "videonetwork";
    OneAppSpecificCustomTag["VideoProgram"] = "videoprogram";
    OneAppSpecificCustomTag["VideoSeason"] = "videoseason";
    OneAppSpecificCustomTag["VideoEpisode"] = "videoepnumber";
    OneAppSpecificCustomTag["VideoTitle"] = "videotitle";
    OneAppSpecificCustomTag["FriendlyName"] = "a.media.friendlyName";
    OneAppSpecificCustomTag["VideoFirstAirDate"] = "videoairdate";
    OneAppSpecificCustomTag["VideoPlayerUrl"] = "videoplayerurl";
    OneAppSpecificCustomTag["VideoDomain"] = "videodomain";
    OneAppSpecificCustomTag["VideoCallsign"] = "videocallsign";
    OneAppSpecificCustomTag["VideoMvpd"] = "videomvpd";
    OneAppSpecificCustomTag["VideoTmsId"] = "videotmsid";
    OneAppSpecificCustomTag["VideoClipType"] = "videocliptype";
    OneAppSpecificCustomTag["VideoScreen"] = "videoscreen";
    OneAppSpecificCustomTag["VideoSport"] = "videosport";
    OneAppSpecificCustomTag["VideoLeague"] = "videoleague";
    OneAppSpecificCustomTag["VideoBroadcast"] = "videobroadcast";
    OneAppSpecificCustomTag["VideoDayPart"] = "videodaypart";
    OneAppSpecificCustomTag["VideoPlayerTech"] = "videoplayertech";
    OneAppSpecificCustomTag["VideoCastSource"] = "videocastsource";
    OneAppSpecificCustomTag["VideoCrossDevice"] = "videocrossdevice";
    OneAppSpecificCustomTag["VideoLanguage"] = "videolanguage";
    OneAppSpecificCustomTag["VideoPassGuid"] = "videopassguid";
    OneAppSpecificCustomTag["VideoRequestorId"] = "videorequestorid";
    OneAppSpecificCustomTag["VideoResearchTitle"] = "videoresearchtitle";
    OneAppSpecificCustomTag["VideoLength"] = "a.media.length";
    OneAppSpecificCustomTag["VideoSponsor"] = "videosponsor";
    return OneAppSpecificCustomTag;
}({});
export var DomainType = /*#__PURE__*/ function(DomainType) {
    DomainType["OnDomain"] = "On-Domain";
    DomainType["OffDomain"] = "Off-Domain";
    return DomainType;
}({});
export var OneAppCustomContentTags = /*#__PURE__*/ function(OneAppCustomContentTags) {
    OneAppCustomContentTags["TrackingId"] = "tracking_id";
    OneAppCustomContentTags["AbTesting"] = "abtestingvariant";
    OneAppCustomContentTags["AppSessionId"] = "appSessionId";
    OneAppCustomContentTags["Brand"] = "brand";
    OneAppCustomContentTags["ConnectionType"] = "connectionType";
    OneAppCustomContentTags["DeviceId"] = "deviceId";
    OneAppCustomContentTags["Entitlement"] = "entitlement";
    OneAppCustomContentTags["EpisodeNumber"] = "episodeNumber";
    OneAppCustomContentTags["EpisodeTitle"] = "episodeTitle";
    OneAppCustomContentTags["Geostation"] = "geostation";
    OneAppCustomContentTags["Mvpd"] = "mvpd";
    OneAppCustomContentTags["Platform"] = "platform";
    OneAppCustomContentTags["PlaybackStartPosition"] = "playbackStartPosition";
    OneAppCustomContentTags["PlayerVendor"] = "playerVendor";
    OneAppCustomContentTags["PlayerVersion"] = "playerVersion";
    OneAppCustomContentTags["PreFetched"] = "preFetched";
    OneAppCustomContentTags["Product"] = "product";
    OneAppCustomContentTags["Profile"] = "profile";
    OneAppCustomContentTags["Season"] = "season";
    OneAppCustomContentTags["Show"] = "show";
    OneAppCustomContentTags["StitchVendor"] = "stitchVendor";
    OneAppCustomContentTags["StreamProtocol"] = "streamProtocol";
    OneAppCustomContentTags["Syndicator"] = "syndicator";
    OneAppCustomContentTags["TmsShowID"] = "tmsShowID";
    OneAppCustomContentTags["Version"] = "version";
    OneAppCustomContentTags["VideoId"] = "videoId";
    OneAppCustomContentTags["VideoType"] = "videoType";
    OneAppCustomContentTags["Sport"] = "sport";
    OneAppCustomContentTags["League"] = "league";
    OneAppCustomContentTags["EventType"] = "eventType";
    OneAppCustomContentTags["MutedVideoStart"] = "mutedVideoStart";
    OneAppCustomContentTags["IsFromBackground"] = "isFromBackground";
    OneAppCustomContentTags["Language"] = "language";
    OneAppCustomContentTags["StreamType"] = "streamtype";
    OneAppCustomContentTags["IsLive"] = "isLive";
    OneAppCustomContentTags["OptedOutSdks"] = "optedOutSdks";
    return OneAppCustomContentTags;
}({});
export var OneAppCustomAdTags = /*#__PURE__*/ function(OneAppCustomAdTags) {
    OneAppCustomAdTags["AdvertiserName"] = "c3.ad.advertiserName";
    OneAppCustomAdTags["CreativeDuration"] = "creativeDuration";
    OneAppCustomAdTags["Csid"] = "c3.csid";
    OneAppCustomAdTags["MrmCampaignID"] = "mrmCampaignID";
    OneAppCustomAdTags["MrmCreativeRenditionID"] = "mrmCreativeRenditionID";
    OneAppCustomAdTags["MrmPlacementID"] = "mrmPlacementID";
    OneAppCustomAdTags["MrmResellerID"] = "mrmResellerID";
    OneAppCustomAdTags["MrmSiteSectionID"] = "mrmSiteSectionID";
    OneAppCustomAdTags["PlacementName"] = "placementName";
    OneAppCustomAdTags["ResellerName"] = "resellerName";
    OneAppCustomAdTags["SiteSection"] = "siteSection";
    OneAppCustomAdTags["SiteSectionTag"] = "siteSectionTag";
    OneAppCustomAdTags["ThirdPartyTagProvider"] = "thirdPartyTagProvider";
    OneAppCustomAdTags["Type"] = "c3.ad.type";
    OneAppCustomAdTags["sequence"] = "c3.ad.sequence";
    return OneAppCustomAdTags;
}({});
export var LegacyReportingStreamType = /*#__PURE__*/ function(LegacyReportingStreamType) {
    LegacyReportingStreamType["VOD"] = "VOD";
    LegacyReportingStreamType["Clip"] = "CLIP";
    LegacyReportingStreamType["Preview"] = "TRAILER";
    LegacyReportingStreamType["Live"] = "LINEAR";
    LegacyReportingStreamType["SingleLiveEvent"] = "SINGLE LIVE EVENT";
    LegacyReportingStreamType["FullEventReplay"] = "FULL EVENT REPLAY";
    return LegacyReportingStreamType;
}({});
export var AdLoadType = /*#__PURE__*/ function(AdLoadType) {
    AdLoadType["passthrough"] = "1";
    AdLoadType["dynamic"] = "2";
    return AdLoadType;
}({});

//# sourceMappingURL=oneapp-reporting.enums.js.map